import { Matching, MatchingDTO, MatchingQuery } from '../models/Matching'
import { Observable } from 'rxjs'
import { Query } from '../../../common/api/Query'
import { ItemList } from '../../../common/models/ItemList'
import { Container, IInit } from '../../../common/container/Container'
import { IStatusService } from '../../../common/status/StatusService'
import { IMatchingApi } from '../api/MatchingApi'
import { STATUS_SERVICE_KEY } from '../../../container/app'

type Props = {
  apiKey: symbol
}

export interface IMatchingService extends IInit {
  getByID(id: string): Observable<Matching | undefined>
  getFilteredList(q: Query<MatchingQuery>): Observable<ItemList<Matching>>
  add(e: MatchingDTO): Observable<Matching | undefined>
  update(e: MatchingDTO): Observable<Matching | undefined>
  delete(id: string): Observable<boolean>
}

export class MatchingService implements IMatchingService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IMatchingApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IMatchingApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  getByID(id: string): Observable<Matching | undefined> {
    return this._api.getByID(id)
  }

  getFilteredList(q: Query<MatchingQuery>): Observable<ItemList<Matching>> {
    return this._api.getFilteredList(q).pipe()
  }

  add(e: MatchingDTO): Observable<Matching | undefined> {
    return this._api.add(e)
  }

  delete(id: string): Observable<boolean> {
    return this._api.delete(id)
  }

  update(e: MatchingDTO): Observable<Matching | undefined> {
    return this._api.update(e)
  }
}
